import appStore from "store";
import { resolve } from "tinymce";
import api from "./api";
import moment from "moment";
const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 10
    },
    withdrawList:[],
    coinGroup:{},
    ooficeList:[],
    historyList:[],
    tagTotal: 0,
    officTotal:0,
    historyTotal:0,
    coinTypes:[]
  },
  mutations: {
    setData(state, payload) {
      state[payload.n] = payload.d;
    },
    setWith(state, payload){
      state.withdrawList = payload
    },
    setTagTotal(state, payload) {
      state.tagTotal = payload;
    },
    setCoinTypes(state, payload) {
      state.coinTypes = payload;
    },
    settingData(state, payload){
      state.coinGroup = payload
    }
  },
  actions: {
    getCoinWithdrawFeeConfigList({ commit }, data){
      api.getCoinWithdrawFeeConfigList(data).then(({data})=>{
        data.records.filter(item=>{
          return item.withdrawFeeType=item.withdrawFeeType==0?'模式一':'模式二';
        })
        commit('setWith',data.records)
        commit('setTagTotal', data.total);
      })
    },
    getCoinGroup({ commit }, data){
      api.getCoinGroup(data).then(({data})=>{
        commit('settingData',data)
      })
    },
    getOfficeList({ commit }, data){
      api.getOfficeList(data).then(({data})=>{
        data.records.map(item=>{
          item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
        })
        commit('setData',{
          n:'ooficeList',
          d: data.records
        })
        commit('setData',{
          n:'officTotal',
          d: data.total
        })
        commit('setData',{
          n:'historyList',
          d: data.records
        })
        commit('setData',{
          n:'historyTotal',
          d: data.total
        })
      })
    },
    remove({ commit }, data){
      commit("setWith", []);
      // commit('setTagTotal', );
    },
    updateWithdraw({ commit }, data){
      return new Promise(resolve => {
        api.updateWithdraw(data).then(res=>{
          resolve(res);
        })
      })
    },
    batchUpdate({ commit }, data){
      return new Promise(resolve => {
        api.batchUpdate(data).then(res=>{
          resolve(res);
        })
      })
    },
    getCoinTypes({ commit }) {
      api.getCoinTypes().then(({ data }) => {
        commit('setCoinTypes', data);
      });
    }
  }
};

appStore.registerModule("withdrawal", store);
